module.exports = __webpack_public_path__ + "img/apple-logo-black.0441dc4.svg";